import React from 'react';
import { Modal, Button } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as IconError } from '../../../assets/sx-icon-exclamation-point.svg';
import { ReactComponent as CrossSVG } from '../../../assets/sightx-icons/svg/x-close.svg';
import { Features, isFeatureEnabled } from '../../../featureToggles/features/index';
import { DangerButton } from '../dangerButton';

import styles from './confirmModal.module.scss';

interface StateProps {
  title: string;
  description: string | JSX.Element;
  okBtnText: string;
  cancelBtnText: string;
  visible: boolean;
}

interface DispatchProps {
  onConfirm: (values: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onClose: () => void;
}

const IS_PLG_EXTERNAL_ENV = isFeatureEnabled(Features.PlgExternal);

export class ConfirmModal extends React.Component<StateProps & DispatchProps> {
  private renderTitle() {
    const { title } = this.props;

    if (!IS_PLG_EXTERNAL_ENV) {
      return null;
    }

    return <div className={styles.titleContainer}>
      <Icon component={IconError} className={styles.modalErrorIcon} />
      <span className={styles.modalTitle}>{title}</span>
    </div>;
  }

  private renderModalForPlgExternal() {
    const { description, onClose, onConfirm, okBtnText, cancelBtnText, visible } = this.props;

    return (
      <Modal
        visible={visible}
        title={this.renderTitle()}
        footer={null}
        onCancel={onClose}
        closeIcon={<Icon component={CrossSVG} className={styles.modalCloseIcon} />}
        width={400}
        centered
      >
        <div className={styles.modalContainer}>
          <div className={styles.modalContentContainer}>
            {description}
          </div>
          <div className={styles.modalFooterContainer}>
            <Button type="default" onClick={onClose}>
              {cancelBtnText}
            </Button>
            <DangerButton
              onClick={onConfirm}
              className={styles.dangerButton}
            >
              {okBtnText}
            </DangerButton>
          </div>
        </div>
      </Modal>
    );

  }

  render(): React.ReactNode {
    if (!IS_PLG_EXTERNAL_ENV) {
      return null;
    }
    // TODO: update this confirm modal to chow a success case or danger case. Confirm first Success button modal]
    return this.renderModalForPlgExternal();
  }
}
